module.exports = __webpack_public_path__ + "img/ring_y_o_0_0.8ed1d72d.png";